if (!customElements.get('schock-product-gallery')) {
  customElements.define('schock-product-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-gallery-thumb]');
        if (button) this.select(button);
      });
      this.addEventListener('keydown', (event) => {
        const button = event.target.closest('[data-gallery-thumb]');
        if (!button || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const buttons = [...this.querySelectorAll('[data-gallery-thumb]')];
        const index = buttons.indexOf(button);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 :
          (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
        buttons[next].focus({ preventScroll: true });
        this.select(buttons[next]);
      });
    }
    select(button) {
      const link = this.querySelector('[data-gallery-image-link]');
      const image = this.querySelector('[data-gallery-image]');
      const url = button.dataset.image;
      link.hidden = !url;
      this.querySelector('[data-gallery-placeholder]').hidden = !!url;
      if (url) { image.src = url; image.alt = button.dataset.caption; link.href = url; }
      this.querySelector('[data-gallery-caption]').textContent = button.dataset.caption;
      this.querySelectorAll('[data-gallery-thumb]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      const strip = button.parentElement;
      if (button.offsetLeft < strip.scrollLeft || button.offsetLeft + button.offsetWidth > strip.scrollLeft + strip.clientWidth) {
        strip.scrollTo({ left: button.offsetLeft - strip.clientWidth / 2 + button.offsetWidth / 2, behavior: 'smooth' });
      }
    }
  });
}
